import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Routes from './routes'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'

Vue.use(VueRouter);
Vue.config.productionTip = false

const router = new VueRouter({
  routes: Routes
});

new Vue({
  render: h => h(App),
  router: router,
}).$mount('#app')
